import { AnimatePresence, motion } from "framer-motion";
import React, { useState } from "react";

const AccordionItem = ({ title, content, defaultActive, newDesignConfig }) => {
  const [isActive, setIsActive] = useState(defaultActive);
  const toggleItem = () => {
    setIsActive((prev) => !prev);
  };
  return (
    <div className="border overflow-hidden pad:flex pad:flex-row pad:items-start">
      <button
        onClick={toggleItem}
        className={`max-w-full pad:max-w-[20rem] px-4 py-4 text-left flex items-center gap-2 font-bold ${
          newDesignConfig
            ? "text-nivabupa-blue-dark"
            : "text-nivabupa-blue-dark"
        }`}
      >
        <span className="text-sky-600">
          {isActive ? (
            <svg
              xmlns="http://www.w3.org/2000/svg"
              fill="none"
              viewBox="0 0 24 24"
              strokeWidth={1.5}
              stroke="currentColor"
              className="w-6 h-6"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                d="M12 9v6m3-3H9m12 0a9 9 0 11-18 0 9 9 0 0118 0z"
              />
            </svg>
          ) : (
            <svg
              xmlns="http://www.w3.org/2000/svg"
              fill="none"
              viewBox="0 0 24 24"
              strokeWidth={1.5}
              stroke="currentColor"
              className="w-6 h-6"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                d="M15 12H9m12 0a9 9 0 11-18 0 9 9 0 0118 0z"
              />
            </svg>
          )}
        </span>

        <span
          className={`text-base pad:text-lg ${
            newDesignConfig && "text-nivabupa-blue-dark"
          }`}
        >
          {title}
        </span>
      </button>

      <AnimatePresence>
        {!isActive && (
          <motion.div
            initial={{ opacity: 0, height: 0 }}
            animate={{ opacity: 1, height: "auto" }}
            exit={{ opacity: 0, height: 0 }}
            className="overflow-hidden pad:w-[70%] pad:ml-auto"
          >
            <div className="p-4">{content}</div>
          </motion.div>
        )}
      </AnimatePresence>
    </div>
  );
};

export default AccordionItem;
